import React, { FC, Fragment, ReactNode, useState } from 'react';

import { cn, InputFilter, resultIf } from '../../../../utils';
import Information from '../../utils/Information';

import './CommonInput.scoped.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  value: any;
  onChange: (value: any) => void;
  title: string;
  helpingText?: ReactNode | undefined;
  required?: boolean | undefined;
  extensions?: Array<ReactNode> | undefined;
  id: string;
  inputFilter?: InputFilter;
}

const CommonInput: FC<Props> = ({
  value,
  onChange,
  title,
  helpingText,
  required = true,
  extensions,
  id,
  inputFilter,
  ...props
}) => {
  const [focused, setFocused] = useState(false);
  const [filterWarningShown, setFilterWarningShown] = useState(false);

  const { className, ...inputProps } = props;

  const active = (): boolean => {
    return focused || value !== '';
  };

  const onInput = (event: React.FormEvent<HTMLInputElement>) => {
    const input = event.currentTarget;
    const raw = input.value;
    if (!inputFilter) {
      onChange(raw);
      return;
    }
    const filtered = inputFilter.filter(raw);
    setFilterWarningShown(filtered !== raw);
    if (filtered !== raw) {
      const caret = inputFilter.filter(raw.slice(0, input.selectionStart ?? raw.length)).length;
      input.value = filtered;
      input.setSelectionRange(caret, caret);
    }
    onChange(filtered);
  };
  const renderExtensions = () => {
    return (
      extensions !== undefined &&
      extensions.map((extension, index) => {
        return <Fragment key={index}>{extension}</Fragment>;
      })
    );
  };
  return (
    <>
      <div className={cn('common-input', className)}>
        <div className="common-input__left">
          <input
            id={id}
            className="common-input__input"
            value={value}
            onInput={onInput}
            onFocus={() => setFocused(true)}
            onBlur={() => {
              setFocused(false);
              setFilterWarningShown(false);
            }}
            {...inputProps}
          />
          <label className={cn('common-input__label', resultIf(active(), 'focused'))} htmlFor={id}>
            {title}
          </label>
        </div>
        <div className="common-input__right">
          {!required && (
            <div className="common-input__disclaimer">
              Необязательно <span className="common-input__disclaimer--mobile">для заполнения</span>
            </div>
          )}
          {helpingText !== undefined && (
            <div>
              <Information>{helpingText}</Information>
            </div>
          )}
          {renderExtensions()}
        </div>
      </div>
      {inputFilter && filterWarningShown && (
        <div className="common-input-warning">{inputFilter.warning}</div>
      )}
    </>
  );
};

export default CommonInput;
